// **************************************************************************************************************
export const buildArticleOptionDisplayData = (articleOptions, articleNumber) => {

    const articleData = articleOptions[articleNumber]

    if (!articleData) {
        return null;
    }

    let badge = false

    if ((articleData.view && articleData.view.badge && articleData.view.badge.enabled)) {
        badge = {
            view: articleData.view.badge.view,
            label: articleData.view.badge.label
        }
    }

    return {
        value: articleNumber,
        display: {
            title: articleData.title,
            description: articleData.description,
            badge: badge,
            inclusiveLabel: articleData.inclusiveLabel,
            background: (articleData.view && articleData.view.background) ? articleData.view.background : false,
            price: {
                setupFee: (articleData.price && articleData.price.default.setupFee) ? articleData.price.default.setupFee : 0,
                priceMonthly: (articleData.price && articleData.price.default.net) ? articleData.price.default.net : 0
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/selectors/Util.js
 **/